import {
    SIZOTSA_APPLICATION_API_STATUS,
    SIZOTSA_APPLICATION_TOGGLE_TNC,
    SET_REFERENCE_DATA_API_DETAILS_VALUE,
    SET_REFERENCE_DATA_VALUE,
    SET_PURCHASE_RESPONSE,
} from '../../actions/sizotsaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../status';

export const initReferenceData = {
    apiDetails: { status: API_CALL_STATUS.IDLE, name: null ,content :null },
    banks: [],
    branchCodes: [],
    purchaseServiceResponse:{},
    agentCodeDetails:{},
    termsandConditions: false,
};

export default (state = initReferenceData, action) => {
    const updateField = (fieldType, value) => ({
        ...state,
        [fieldType]: value,
    });
    switch (action.type) {
        case SET_REFERENCE_DATA_VALUE:
            return updateField(action.value?.fieldType, action.value?.value);
        case SET_REFERENCE_DATA_API_DETAILS_VALUE:
            return {
                ...state,
                apiDetails: { ...action.value },
            };
        case SIZOTSA_APPLICATION_TOGGLE_TNC:
            return { ...state, termsandConditions: action.value };
        case SIZOTSA_APPLICATION_API_STATUS:
            return { ...state, apiStatus: action.value };
        case SET_PURCHASE_RESPONSE:
            return {...state, purchaseServiceResponse: action.value };
        default:
            return state;
    }
};
